// Entry of index.html: the app's modules read the runtime config while they load.
import { loadRuntimeConfig } from '@/lib/runtimeConfig'

void loadRuntimeConfig().then(() => import('./main'))
